import type { EditableFieldType } from "./types";

const PREVIEW_PARAM = "cmsPreview";

export function isCmsPreviewMode(): boolean {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.get(PREVIEW_PARAM) === "1";
}

export function editableAttrs(path: string, type: EditableFieldType = "text") {
  if (!isCmsPreviewMode()) return {};
  return {
    "data-cms-editable": "true",
    "data-cms-path": path,
    "data-cms-type": type,
  } as const;
}

export const CMS_PREVIEW_EVENT = "cms-preview-selection";
